<template lang="pug">
section.section(
    :class="classes"
    @click="editSection"
)
    include /components/Page/Sections/base.pug
    .content-wrappers(v-if="!isEmpty || $slots.default")
        slot
        template(v-if="!disabled")
            .preview(v-if="section.pages && section.pages.length")
                .content-wrapper
                    template(v-if="section.pages.length === 1") {{ $t('1 page') }}
                    template(v-else) {{ $t('{count} pages', { count: section.pages.length }) }}
            .error(v-else)
                el-alert(type="warning" :title="$t('No pages selected')")

    el-drawer.full-height-drawer.visible-overflow(
        v-if="editable"
        :title="$t('Edit {section}', { section: section.name })"
        :visible.sync="scopedUI.form"
        :close-on-press-escape="true"
        :wrapper-closable="false"
        :append-to-body="true"
        size="920px"
        :modal="true"
        @closed="reset"
    )
        .drawer-body(v-loading="drawer.loading")
            el-tabs(
                v-if="!drawer.loading"
                v-model="drawer.tab"
                tab-position="top"
            )
                el-tab-pane(name="content" :label="$t('Content')")
                    .tab-content
                        .content-wrapper
                            .edit(v-if="edit")
                                paginated-items(
                                    v-if="drawer.section && drawer.section.pages && drawer.section.pages.length"
                                    :scope="pagination.scope"
                                    :type="pagination.type"
                                    :loading="pagination.loading"
                                    :items="pagination.items"
                                    :filters="pagination.filters"
                                    :show-filters="showFilters"
                                    :variables="pagination.variables"
                                    :all-columns="allColumns"
                                    :active-columns="activeColumns"
                                    :page-info="pagination.pageInfo"
                                    @change-filter="changeFilter"
                                    @show-table-columns="changeTableColumns"
                                    @pagination-size-change="changePaginationSize"
                                    @pagination-current-change="changeCurrentPage"
                                )
                                    template(slot="top")
                                        el-row.table-top(v-loading="pagination.loading" type="flex" justify="space-between")
                                            .left
                                                el-button.open-page-modal-button(
                                                    size="mini"
                                                    type="primary"
                                                    icon="el-icon-fa-plus fas"
                                                    @click="openPageModal"
                                                )
                                                    | {{ $t('Add Pages') }}
                                            .right.hide-on-empty
                                                el-button(
                                                    plain
                                                    size="mini"
                                                    type="primary"
                                                    icon="el-icon-fa-filter fas"
                                                    @click="toggleFilterVisiblity"
                                                    :disabled="disable.showFilters || hasFilters"
                                                )
                                                    span(v-if="showFilters") {{ $t('Hide filters') }}
                                                    span(v-else) {{ $t('Show filters') }}
                                    template(v-slot:actions="{ item }")
                                        el-button.delete-button(
                                            v-if="! isPageDeleted(item)"
                                            plain
                                            circle
                                            size="mini"
                                            type="danger"
                                            icon="el-icon-fa-trash-alt far"
                                            @click.stop.prevent="removePageFromSection(item)"
                                        )
                                        el-button.restore-button(
                                            v-else
                                            plain
                                            circle
                                            size="mini"
                                            type="info"
                                            icon="el-icon-fa-trash-restore fas"
                                            @click.stop.prevent="restorePageInSection(item)"
                                        )
                                    template(v-slot:info-before:th)
                                        .col-center #
                                    template(v-slot:info-before="{ item }")
                                        .col-center
                                            input.position-input(
                                                type="number"
                                                :value="getPosition(item.id)"
                                                @change="$event => changePagePosition(item, $event.target.value)"
                                            )
                                .no-pages(v-else)
                                    el-alert(
                                        :title="$t('No pages selected')"
                                        type="warning"
                                        effect="light"
                                        :closable="false"
                                    )
                                    el-button.open-page-modal-button(
                                        size="mini"
                                        type="primary"
                                        icon="el-icon-fa-plus fas"
                                        @click="openPageModal"
                                    )
                                        | {{ $t('Add Pages') }}

                el-tab-pane(name="settings" :label="$t('Settings')")
                    .block-settings
                        .settings-wrap
                            include /components/Page/Sections/settings.pug
        .drawer-footer
            include /components/Page/Sections/section-drawer-footer.pug

        //- el-dialog.add-pages-dialog(
        //-     :title="$t('Add Pages')"
        //-     :visible.sync="modal.visibility"
        //-     :close-on-click-modal="false"
        //-     :modal-append-to-body="false"
        //-     top="10vh"
        //-     width="1536px"
        //-     @closed="resetModal"
        //- )

    el-drawer.page-list-drawer(
        :title="$t('Add Pages')"
        :visible.sync="modal.visibility"
        :wrapper-closable="false"
        :append-to-body="true"
        :modal="true"
        size="90%"
        @closed="resetModal"
    )
        .drawer-body(v-loading="modal.loading")
            el-form.pages-modal-form(
                ref="form"
                :model="modal.form"
                label-position="top"
                :rules="modal.rules"
                v-loading="modal.loading"

                @submit.prevent.native="addPagesToSection"
            )
                transition(name="slide-vertical")
                    .modal-body-pagination(v-if="! modal.loading")
                        paginated-items(
                            :scope="modal.pagination.scope"
                            :type="modal.pagination.type"
                            :loading="modal.pagination.loading"
                            :items="modal.pagination.items"
                            :filters="modal.pagination.filters"
                            :show-filters="true"
                            :variables="modal.pagination.variables"
                            :all-columns="allColumns"
                            :active-columns="activeColumns"
                            :page-info="modal.pagination.pageInfo"
                            @change-filter="changeModalFilter"
                            @show-table-columns="changeModalTableColumns"
                            @pagination-size-change="changeModalPaginationSize"
                            @pagination-current-change="changeModalCurrentPage"
                            @click="toggleModalPage"
                        )
                            template(v-slot:actions="{ item }")
                                template(v-if="isModalItemInSection(item)")
                                    el-button.delete-button(
                                        v-if="! isPageDeleted(item)"
                                        plain
                                        circle
                                        size="mini"
                                        type="danger"
                                        icon="el-icon-fa-trash-alt far"
                                        @click.stop.prevent="removePageFromSection(item)"
                                    )
                                    el-button.restore-button(
                                        v-else
                                        plain
                                        circle
                                        size="mini"
                                        type="success"
                                        icon="el-icon-fa-trash-restore fas"
                                        @click.stop.prevent="restorePageInSection(item)"
                                    )
                                el-switch(
                                    v-else
                                    :key="item.id"
                                    :value="isModalPageSelected(item)"
                                    @change="enabled => toggleModalPage(item)"
                                )

        //- template(slot="footer")
        .drawer-footer
            el-button(
                round
                size="mini"
                icon="el-icon-fa-times fas"
                @click="closeModal"
            ) {{ $t('Dismiss') }}
            el-button(
                round
                size="mini"
                :disabled="modal.loading"
                type="primary"
                icon="el-icon-fa-check fas"
                @click="addPagesToSection"
            ) {{ $t('Ok') }}
</template>

<i18n>
{
    "en": {
        "Edit {section}": "Edit {section}",
        "{count} pages": "{count} pages"
    },
    "de": {
        "Edit {section}": "{section} bearbeiten",
        "Content": "Inhalt",
        "Settings": "Einstellungen",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "No pages selected": "Es sind keine Beiträge ausgewählt",
        "Page list could not be fetched.": "Beitragsliste konnte nicht abgerufen werden.",
        "Add Pages": "Beiträge hinzufügen",
        "1 page": "1 Beitrag",
        "{count} pages": "{count} Beiträge",
        "Margin top": "Abstand oben",
        "Margin bottom": "Abstand unten",
        "none": "Ohne",
        "small": "Klein",
        "medium": "Mittel",
        "large": "Groß",
        "default": "Standard",
        "custom": "Benutzerdefiniert",
        "Everybody": "Jedem",
        "Members": "Mitgliedern",
        "Guests": "Gästen",
        "Any": "Alle",
        "Tags": "Tags",
        "Select tags": "Tags auswählen",
        "Accessible by": "Zugänglich von",
        "desktop": "Desktop",
        "tablet": "Tablet",
        "mobile": "Telefon",
        "Visible on":"Anzeigen auf",
        "Element is displayed on":"Inhaltselement <br> wird dargestellt auf"
    }
}
</i18n>

<script>
import _ from 'lodash';

import pinia from '@/pinia';
import { useAuthStore, useSetupStore } from '@/stores';

import PageApi from '@/store/api/cms/page';
import { reorderItemsByPosition } from '@/helpers';

import Section from '@/components/Page/Sections/Section';
import PaginatedItems from '@/components/PaginatedItems';

import { adminClient as apolloClient } from '@/store/apollo';

export default {
    name: 'Pages',
    extends: Section,
    data: () => ({
        modal: {
            visibility: false,
            loading: false,
            rules: {},
            form: {
                pages: []
            },
            pagination: {
                type: 'section_page',
                scope: 'cp',
                loading: false,
                items: [],
                filters: {},
                variables: {
                    withCategory: true,
                    paginationSizes: [10, 20, 50]
                },
                pageInfo: {
                    currentPage: 1,
                    lastPage: 1,
                    perPage: 20,
                    total: 0
                }
            }
        },
        allColumns: [],
        activeColumns: [],
        pagination: {
            type: 'section_page',
            scope: 'cp',
            showFilters: false,
            loading: false,
            items: [],
            filters: {},
            variables: {
                withCategory: true,
                paginationSizes: [10, 20, 50]
            },
            pageInfo: {
                currentPage: 1,
                lastPage: 1,
                perPage: 10,
                total: 0
            }
        },
        disable: {
            showFilters: false
        }
    }),
    components: {
        PaginatedItems
    },
    watch: {
        'section.pages'(current, previous) {
            if (current.length !== previous.length) {
                // this.debouncedRefetchPagination();
                this.refetchPagination();
            }
        }
    },
    computed: {
        editable() {
            return true;
        },
        isEmpty() {
            // let empty = !this.$slots.default
            let empty = true

            if (empty && this.section.pages && this.section.pages.length) empty = false

            // if (empty && this.section.informations && this.section.informations.length) empty = false
            // if (empty && this.section.eventCategories && this.section.eventCategories.length) empty = false
            // if (empty && this.section.shopCategories && this.section.shopCategories.length) empty = false
            // if (empty && this.section.pages && this.section.pages.length) empty = false

            // const contents = _.get(this.section, 'contents') || []
            // contents.forEach(content => {
            //     if (! empty) return
            //     if (content.addresses && content.addresses.length) empty = false
            //     if (content.images && content.images.length) empty = false
            //     if (content.media && content.media.length) empty = false
            //     if (content.title || content.sub_title || content.text) empty = false
            // })

            return empty
        },
        showFilters() {
            return this.hasFilters || _.get(this.pagination, 'showFilters') || false;
        },
        hasFilters() {
            return !_.isEmpty(this.filters);
        },
        filters() {
            let filters = _.cloneDeep(this.pagination.filters);
            delete filters.cms;
            delete filters.category_keys;
            delete filters.category;
            delete filters.ids;
            return filters;
        },
        user() {
            return useAuthStore().user;
        },
        setupStore() {
            return useSetupStore(pinia);
        },
    },
    methods: {
        getPosition(id) {
            const section = this.drawer.section || this.section
            const page = section.pages.find(item => parseInt(item.id) === parseInt(id));
            if (page && page.pivot && page.pivot.position) return page.pivot.position;
            else return '-'
        },
        changePagePosition(page, newPosition) {
            const section = this.drawer.section || this.section;
            reorderItemsByPosition(section.pages, page.id, newPosition);
            this.refetchPagination();
        },
        reset() {
            this.resetDrawer()
            this.pagination = {
                type: 'section_page',
                scope: 'cp',
                showFilters: false,
                loading: false,
                items: [],
                filters: {},
                variables: {
                    withCategory: true,
                    paginationSizes: [10, 20, 50]
                },
                pageInfo: {
                    currentPage: 1,
                    lastPage: 1,
                    perPage: 10,
                    total: 0
                }
            }

            this.$nextTick(this.refetchPagination)
        },
        async fetchPagesPaginated(payload) {
            return PageApi.fetchPagesPaginated(payload);
        },
        defineActiveColumns(activeColumnKeys) {
            let activeColumns = [];
            _.each(this.allColumns, column => {
                let allowed = _.find(activeColumnKeys, el => column.key === el.key);
                if (allowed) activeColumns.push(column);
            });

            if (activeColumns.length) {
                this.activeColumns = _.cloneDeep(activeColumns);
            }
        },
        openPageModal() {
            this.modal.loading = true
            this.modal.visibility = true;

            // set cms filter
            if (this.activeCms) {
                const key = 'cms';
                const value = {
                    key,
                    match: this.activeCms.id,
                    like: '',
                    from: '',
                    to: '',
                    in: []
                };
                this.$set(this.modal.pagination.filters, key, value);
            }

            this.refetchModalPagination();
        },

        refetchPagination() {
            const section = this.drawer.section || this.section

            this.pagination.loading = true;

            const pages = section.pages || [];
            const sortedPages = _.sortBy(pages, item => _.get(item, 'pivot.position', 0));

            const key = 'ids';
            const value = {
                key,
                match: '',
                like: '',
                from: '',
                to: '',
                in: sortedPages.map(item => item.id)
            };
            this.$set(this.pagination.filters, key, value);
            this.$set(this.pagination.variables, 'order', 'filter:ids');

            this.fetchPagesPaginated(this.pagination)
                .then(data => {
                    this.pagination.items = _.cloneDeep(data.items);
                    this.pagination.pageInfo = _.cloneDeep(data.pageInfo);
                    this.pagination.showFilters = _.get(data.config, 'showFilters') || false;

                    this.allColumns = _.cloneDeep(data.config.allColumns);
                    this.defineActiveColumns(data.config.activeColumnKeys);
                })
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Page list could not be fetched.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .finally(() => {
                    this.pagination.loading = false;
                });
        },
        debouncedRefetchPagination: _.debounce(function() {
            // function scope is needed here
            this.refetchPagination();
        }, useSetupStore(pinia).debounce || 300),
        changeFilter(key, value, debounce = true) {
            this.$set(this.pagination.filters, key, value);
            this.pagination.pageInfo.currentPage = 1;
            if (debounce) this.debouncedRefetchPagination();
            else this.refetchPagination();
        },
        changeTableColumns(visibleColumns) {
            this.defineActiveColumns(visibleColumns.map(key => ({ key })));
            // apolloClient.cache.reset()
            apolloClient.clearStore();
        },
        changePaginationSize(itemsPerPage) {
            this.pagination.pageInfo.currentPage = 1;
            this.pagination.pageInfo.perPage = itemsPerPage;
            this.refetchPagination();
        },
        changeCurrentPage(currentPage) {
            this.pagination.pageInfo.currentPage = currentPage;
            this.refetchPagination();
        },
        toggleFilterVisiblity() {
            const visible = this.showFilters;

            let value = false;
            if (!visible) value = true;

            this.disable.showFilters = true;
            this.pagination.showFilters = value;

            this.saveFilterVisibility({
                scope: this.pagination.scope,
                key: this.pagination.type,
                value,
            }).finally(() => (this.disable.showFilters = false));
        },

        refetchModalPagination() {
            this.modal.pagination.loading = true;
            this.fetchPagesPaginated(this.modal.pagination)
                .then(data => {
                    this.modal.pagination.items = data.items;
                    this.modal.pagination.pageInfo = _.cloneDeep(data.pageInfo);
                    // this.modal.pagination.showFilters = _.get(data.config, 'showFilters') || false;

                    this.allColumns = _.cloneDeep(data.config.allColumns);
                    this.defineActiveColumns(data.config.activeColumnKeys);
                })
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Page list could not be fetched.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .finally(() => {
                    this.modal.pagination.loading = false;
                    this.modal.loading = false;
                });
        },
        debouncedRefetchModalPagination: _.debounce(function() {
            // function scope is needed here
            this.modal.pagination.loading = true;
            this.refetchModalPagination();
        }, useSetupStore(pinia).debounce || 300),

        closeModal() {
            this.modal.visibility = false;
        },
        resetModal() {
            // TODO
            this.modal = {
                visibility: false,
                loading: false,
                rules: {},
                form: {
                    pages: []
                },
                pagination: {
                    type: 'section_page',
                    scope: 'cp',
                    loading: false,
                    items: [],
                    filters: {},
                    variables: {
                        withCategory: true,
                        paginationSizes: [10, 20, 50]
                    },
                    pageInfo: {
                        currentPage: 1,
                        lastPage: 1,
                        perPage: 20,
                        total: 0
                    }
                }
            };
        },
        changeModalFilter(key, value, debounce = true) {
            this.$set(this.modal.pagination.filters, key, value);
            this.modal.pagination.pageInfo.currentPage = 1;
            if (debounce) this.debouncedRefetchModalPagination();
            else this.refetchModalPagination();
        },
        changeModalTableColumns(visibleColumns) {
            this.defineActiveColumns(visibleColumns.map(key => ({ key })));
            // apolloClient.cache.reset()
            apolloClient.clearStore();
        },
        changeModalPaginationSize(itemsPerPage) {
            this.modal.pagination.loading = true;
            this.modal.pagination.pageInfo.currentPage = 1;
            this.modal.pagination.pageInfo.perPage = itemsPerPage;
            this.refetchModalPagination();
        },
        changeModalCurrentPage(currentPage) {
            this.modal.pagination.loading = true;
            this.modal.pagination.pageInfo.currentPage = currentPage;
            this.refetchModalPagination();
        },
        isModalPageSelected(item) {
            return !!this.modal.form.pages.find(el => parseInt(el.id) === parseInt(item.id));
        },
        toggleModalPage(item) {
            if (this.isModalItemInSection(item)) {
                if (this.isPageDeleted(item)) {
                    // const payload = {
                    //     i: this.i,
                    //     // p: this.p,
                    //     s: this.s,
                    //     page: { id: item.id }
                    // };
                    // store.commit(`${this.module}/form/restorePageInSection`, payload);

                    this.restorePageInSection(item);
                } else {
                    // const payload = {
                    //     i: this.i,
                    //     // p: this.p,
                    //     s: this.s,
                    //     page: { id: item.id }
                    // };
                    // store.commit(`${this.module}/form/removePageFromSection`, payload);

                    this.removePageFromSection(item)
                }
            } else {
                const index = _.findIndex(this.modal.form.pages, el => parseInt(el.id) === parseInt(item.id));
                if (index >= 0) {
                    // remove
                    this.$delete(this.modal.form.pages, index);
                } else {
                    // add
                    this.$set(this.modal.form.pages, this.modal.form.pages.length, { id: item.id });
                    // this.modal.form.pages.push(item.id)
                }
            }
        },
        isModalItemInSection(item) {
            const section = this.drawer.section || this.section
            return !!section.pages.find(el => parseInt(el.id) === parseInt(item.id));
        },
        isPageDeleted(item) {
            const section = this.drawer.section || this.section
            return !!section.pages.find(el => parseInt(el.id) === parseInt(item.id) && el.deleted === true);
        },
        removePageFromSection(page) {
            const section = this.drawer.section || this.section

            // this.$set(item, 'deleted', true)

            // const payload = {
            //     i: this.i,
            //     // p: this.p,
            //     s: this.s,
            //     page
            // };
            // store.commit(`${this.module}/form/removePageFromSection`, payload);

            const pages = section.pages || [];
            const p = _.findIndex(pages, el => parseInt(el.id) === parseInt(page.id));
            if (p >= 0) this.$set(section.pages[p], 'deleted', true);
        },
        restorePageInSection(page) {
            const section = this.drawer.section || this.section

            const pages = section.pages || [];
            const p = _.findIndex(pages, el => parseInt(el.id) === parseInt(page.id));
            if (p >= 0) this.$delete(section.pages[p], 'deleted');
        },
        addPagesToSection() {
            const section = this.drawer.section || this.section

            const initialPages = _.cloneDeep(section.pages);
            const modalPages = _.cloneDeep(this.modal.form.pages);

            // const payload = {
            //     i: this.i,
            //     // p: this.p,
            //     s: this.s,
            //     pages: [...modalPages, ...initialPages]
            // };
            // store.commit(`${this.module}/form/sectionPages`, payload);

            const pages = [...modalPages, ...initialPages].map((el, i) => {
                if (!el.pivot) el.pivot = { position: 0 }
                el.pivot.position = i + 1;
                return el
            })

            this.$set(section, 'pages', pages);

            this.closeModal();

            // fetch section pages
            // TODO: fix deletion marks

            this.$nextTick(() => {
                this.refetchPagination();
            });
        },
        saveFilterVisibility(payload) {
            return this.setupStore.saveFilterVisibility(payload);
        }
    },
    mounted() {
        const section = this.drawer.section || this.section

        // set cms filter
        if (this.activeCms) {
            this.$set(this.pagination.filters, 'cms', {
                key: 'cms',
                match: this.activeCms.id,
                like: '',
                from: '',
                to: '',
                in: []
            });

            const configCategories = _.get(this.activeCms.config, 'template.categories') || [];
            const categoryKeys = configCategories.map(el => el.key);
            if (categoryKeys.length) {
                this.$set(this.pagination.filters, 'category_keys', {
                    key: 'category_keys',
                    match: '',
                    like: '',
                    from: '',
                    to: '',
                    in: categoryKeys
                });
            } else {
                // return empty result if cms has no categories
                this.$set(this.pagination.filters, 'category', {
                    key: 'category',
                    match: 0,
                    like: '',
                    from: '',
                    to: '',
                    in: []
                });
            }
        } else {
            // return empty result if no cms is active
            this.$set(this.pagination.filters, 'cms', {
                key: 'cms',
                match: 0,
                like: '',
                from: '',
                to: '',
                in: []
            });
        }

        if (section.pages && section.pages.length) {
            this.refetchPagination();
        }
    }
};
</script>

<style lang="sass" scoped>
// #body .full-height-drawer .drawer-body .el-tabs__content
.viewports
    margin-right: 12px
    .el-tooltip
        margin: 0 3px
        color: #9ca3af
        .inner
            text-align: center
.edit .paginated-items
    background: none
    font-size: .85rem
    line-height: 1.3
    margin-left: -20px
    margin-right: -20px
    // margin-bottom: 10px
    :deep()
        tr
            th.actions,
            td.actions
                width: 60px
                min-width: 0
        .table-top
            padding-top: 0
            padding-left: 20px
            padding-right: 20px
            min-height: 0

.position-input
    width: 60px
    text-align: center
    padding: 4px 0
    border: 1px solid #dcdfe6
    border-radius: 4px
    font-size: inherit
    -moz-appearance: textfield
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button
        -webkit-appearance: none
        margin: 0
    &:focus
        outline: none
        border-color: #409eff

.page-list-drawer .drawer-body
    height: calc(100vh - 134px)
    overflow: auto

.no-pages
    .el-alert
        margin-bottom: 1rem
</style>
